<user-desktop-navbar *ngIf="!this.isMobile"></user-desktop-navbar>
<user-mobile-navbar *ngIf="this.isMobile"></user-mobile-navbar>